import BraMobil from './bramobil.svg';
import CompareRepair from './comparerepair.svg';
import Holo from './holo.svg';
import Frodas from './frodas.svg';

export { BraMobil, CompareRepair, Holo, Frodas };
